import React from "react";
import { motion } from "framer-motion";

const ExpandedRow = ({ row, component, colSpan, isExpanded }) => {
  if (!isExpanded) return null;

  return (
    <motion.tr
      initial={{ height: 0 }}
      animate={{
        height: "auto",
        transition: { duration: 0.25 },
      }}
      style={{ display: "flex", overflow: "hidden" }}
    >
      <td colSpan={colSpan} style={{ width: "100%" }}>
        {component({...row, isExpanded})}
      </td>
    </motion.tr>
  );
};

export default ExpandedRow;
